module.exports = __webpack_public_path__ + "img/Right Barbell.f42ad256.png";